module.exports = __webpack_public_path__ + "img/tie-hair.53bde08f.jpg";